import { css, Theme, SerializedStyles } from "@emotion/react"

export const addressHelpTextStyle = css`
	color: #374151;
	font-size: 16px;
	font-weight: 400;
`

export const addressTextStyle = css`
	flex-shrink: 0;
	color: #111827;
	font-size: 14px;
	font-weight: 500;
`

export const addAddressButtonTextStyle = css`
	text-transform: none;
	color: #0b75e1;
	text-align: center;
	font-size: 14px;
	font-weight: 700;
`

export const addressContainerStyle = css`
	width: 100%;
	padding: 16px;
	flex-shrink: 0;
	border-radius: 4px;
	background: #f3f4f6;
`

export const addAddressButtonContainerStyle = (theme: Theme): SerializedStyles => css`
	${theme.breakpoints.up("md")} {
		display: flex;
		justify-content: flex-end;
	}
`

export const addAddressButtonStyle = (theme: Theme): SerializedStyles => css`
	width: 232px;
	height: 50px;
	flex-shrink: 0;
	border-radius: 4px;
	border: 1px solid #0b75e1;

	${theme.breakpoints.up("md")} {
		width: 144px;
		height: 50px;
		flex-shrink: 0;
	}
`

export const additionalCommentsStyle = css`
	textarea {
		height: 72px;
		font-size: 14px;
		font-weight: 500;
		line-height: 16px;
		color: #374151;
	}

	div.additionalCommentsStyle {
		margin-bottom: 0;
	}
`

export const changeAddressTextStyle = css`
	color: #0b75e1;
	text-align: center;
	font-size: 14px;
`

export const placeOrderButtonStyle = css`
	border-radius: 0.5rem;
	font-weight: 700;
`

export const linkStyle = css`
	font-size: 0.6875rem;
	color: #0b75e1;
	text-decoration: underline;
	font-weight: 400;
`

export const disclaimerStyle = css`
	color: #4b5563;
	font-size: 0.6875rem;
	font-weight: 400;
	margin-bottom: 0.2rem;
`

export const disclaimerWrapperStyle = css`
	margin-top: 0.5rem;
`

export const totalLabelStyle = css`
	color: #003264;
	font-size: 1.25rem;
	font-weight: 400;
`
export const totalLabelTariffStyle = css`
	color: #003264;
	font-size: 1.25rem;
	font-weight: 700;
`
export const purchaseLabelStyle = css`
	color: #111827;
	font-size: 0.875rem;
	font-weight: 500;
`

export const itemCountStyle = css`
	color: #6b7280;
	font-size: 0.875rem;
	margin-top: -1rem;
	margin-bottom: 0.8rem;
`

export const purchaseOrderOptionalStyle = css`
	color: #6b7280;
	font-size: 0.875rem;
`

export const purchaseOrderStyle = css`
	display: flex;
	align-items: center;
	justify-content: space-between;
	input {
		padding: 0.7rem;
	}

	div {
		width: 100%;
	}
`

export const purchaseOrderTariffStyle = css`
	display: flex;
	align-items: center;
	justify-content: space-between;
	input {
		padding: 0.7rem;
	}

	div {
		width: 100%;
	}
`

export const orderSummaryCardStyle = (theme: Theme): SerializedStyles => css`
	position: sticky;
	top: 1rem;
	width: 25rem;
	margin-top: 2rem;
	padding: 1.5rem;
	align-self: start;
	background: #ffffff;
	box-shadow: 0 0 0.375rem 0 #d1d5db;
	border-radius: 0.5rem;
	background-color: white;
	border: 2px solid transparent;
	max-height: 100%;
	font-family: ${theme.typography.fontFamily};

	${theme.breakpoints.down("sm")} {
		position: relative;
		top: 0;
		width: auto;
	}
`
export const headingStyle = css`
	h3 {
		font-size: 1.25rem;
		font-weight: 700;
	}
`

export const ModalErrorContentStyle = (theme: Theme): SerializedStyles => css`
	margin-bottom: 1rem;
	font-family: ${theme.typography.fontFamily};
`

export const ModalErrorFooterCTAStyle = (theme: Theme): SerializedStyles => css`
	font-weight: 700;
	text-decoration: underline;
	color: #0b75e1;
	font-size: 1rem;
	font-family: ${theme.typography.fontFamily};
	background: none;
	border: none;
	padding: 0;
	margin: 0;
`

export const ModalErrorContentContainerStyle = css`
	text-align: center;
	margin-top: 2.5rem;
	font-family: Atlas Grotesk;
`

export const ModalErrorContentTitleStyle = css`
	font-size: 1.5rem;
	font-weight: 700;
	text-align: center;
	margin-bottom: 1rem;
	margin-top: 1.5rem;
`

export const ModalErrorReasonStyle = css`
	font-size: 1rem;
	font-weight: 500;
`

export const ModalErrorContentDescriptionStyle = css`
	font-size: 0.875rem;
	font-weight: 400;
	margin-bottom: 1rem;
`

export const ModalErrorButtonStyle = css`
	width: 156px;
	border-radius: 0.5rem;
	padding: 1rem 1.5rem;
`

export const ModalErrorActionsStyle = css`
	padding: 0 !important;
	box-shadow: 0 0 6px rgba(0, 0, 0, 0.08);
`
